import { render, staticRenderFns } from "./_top-casino-malaysia-april-2026.vue?vue&type=template&id=564f3320&scoped=true&lang=pug&"
import script from "./_top-casino-malaysia-april-2026.vue?vue&type=script&lang=js&"
export * from "./_top-casino-malaysia-april-2026.vue?vue&type=script&lang=js&"
import style0 from "./_top-casino-malaysia-april-2026.vue?vue&type=style&index=0&id=564f3320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f3320",
  null
  
)

export default component.exports